import { render } from "./Review.vue?vue&type=template&id=cb6c85e4&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=cb6c85e4&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6c85e4"]])

export default __exports__